document.addEventListener("turbolinks:load", function() {
  // 既存のイベントハンドラを削除して重複を防ぐ
  $(document).off("click", ".add-internal-operation-row");
  $(document).off("click", ".add-internal-operation-bottom");
  $(document).off("change", "select[id=working_time_leave_class]");
  $(document).off("click", ".remove-internal-operation");
  $(document).off("change", '#internal-operations-container select[name*="[begin("], #internal-operations-container select[name*="[end("]');

  // ページ読み込み時にsort_orderを初期化
  initializeSortOrder();

  // Function to calculate and set operation time
  function calculateOperationTime(row) {
    var beginHour = parseInt(row.find('select[name*="[begin(4i)]"]').val(), 10);
    var beginMin = parseInt(row.find('select[name*="[begin(5i)]"]').val(), 10);
    var endHour = parseInt(row.find('select[name*="[end(4i)]"]').val(), 10);
    var endMin = parseInt(row.find('select[name*="[end(5i)]"]').val(), 10);

    if (!isNaN(beginHour) && !isNaN(beginMin) && !isNaN(endHour) && !isNaN(endMin)) {
      var beginTotalMinutes = beginHour * 60 + beginMin;
      var endTotalMinutes = endHour * 60 + endMin;
      var durationInMinutes = endTotalMinutes - beginTotalMinutes;

      if (durationInMinutes >= 0) {
        var durationHours = Math.floor(durationInMinutes / 60);
        var durationMinutes = durationInMinutes % 60;

        row.find('select[name*="[operation_hour]"]').val(durationHours);
        row.find('select[name*="[operation_min]"]').val(durationMinutes);
      }
    }
  }

  // Event listener for begin/end time changes
  $(document).on("change", '#internal-operations-container select[name*="[begin("], #internal-operations-container select[name*="[end("]', function() {
    var currentRow = $(this).closest('.form-row');
    calculateOperationTime(currentRow);
  });
  
  $(document).on("change", "select[id=working_time_leave_class]", function (e) {

    if (e.currentTarget.value !== "time_paid_vacation") {

      // 開始時間を 00:00 に設定
      document.getElementById("working_time_begin_4i").value = "00";
      document.getElementById("working_time_begin_5i").value = "00";

      // 終了時間を 00:00 に設定
      document.getElementById("working_time_end_4i").value = "00";
      document.getElementById("working_time_end_5i").value = "00";

      // 休憩時間を 00:00 に設定
      document.getElementById("working_time_break_hour").value = "0";
      document.getElementById("working_time_break_min").value = "0";

    }

  });

  // 社内業務の削除ボタン機能
  $(document).on("click", ".remove-internal-operation", function(e) {
    e.preventDefault();
    
    var currentRow = $(this).closest('.form-row');
    
    // 既存のデータの場合は_destroy属性を設定
    var destroyInput = currentRow.find('input[name$="[_destroy]"]');
    if (destroyInput.length > 0) {
      destroyInput.val('1');
    } else {
      // 新規追加の場合は_destroy属性を追加
      var operationInput = currentRow.find('select[name$="[operation]"]');
      if (operationInput.length > 0) {
        var inputName = operationInput.attr('name').replace('[operation]', '[_destroy]');
        currentRow.append('<input type="hidden" name="' + inputName + '" value="1">');
      }
    }
    
    // 行を非表示にする
    currentRow.hide();
    
    // 削除後にsort_orderを再設定
    updateSortOrder();
  });

  // 社内業務の追加ボタン機能（行内の追加ボタン）
  $(document).on("click", ".add-internal-operation-row", function(e) {
    e.preventDefault();
    e.stopPropagation(); // イベントのバブリングを停止
    
    var currentRow = $(this).closest('.form-row');
    
    // インデックスを取得
    var time = new Date().getTime();
    
    // テンプレートから新しい行を作成
    var template = $('#internal-operation-template').html();
    var newHtml = template.replace(/__INDEX__/g, time);
    
    // 新しい行を現在の行の上に追加
    currentRow.before(newHtml);
    
    // sort_orderを再設定
    updateSortOrder();
  });

  // 社内業務の追加ボタン機能（一番下の追加ボタン）
  $(document).on("click", ".add-internal-operation-bottom", function(e) {
    e.preventDefault();
    e.stopPropagation(); // イベントのバブリングを停止
    
    var container = $('#internal-operations-container');
    var addButtonRow = $(this).closest('.form-row');
    
    // インデックスを取得
    var time = new Date().getTime();
    
    // テンプレートから新しい行を作成
    var template = $('#internal-operation-template').html();
    var newHtml = template.replace(/__INDEX__/g, time);
    
    // 新しい行を追加ボタンの直前に追加
    addButtonRow.before(newHtml);
    
    // sort_orderを再設定
    updateSortOrder();
  });

});

// sort_orderを初期化する関数
function initializeSortOrder() {
  updateSortOrder();
}

// sort_orderを更新する関数（最適化版）
function updateSortOrder() {
  var container = $('#internal-operations-container');
  var visibleRows = container.find('.internal-operation-row:visible').not('.form-row:last-child');
  
  visibleRows.each(function(index) {
    var row = $(this);
    var sortOrderInput = row.find('input[name$="[sort_order]"]');
    
    if (sortOrderInput.length) {
      sortOrderInput.val(index);
    } else {
      // sort_order入力フィールドがない場合は追加
      var operationInput = row.find('select[name$="[operation]"]');
      if (operationInput.length) {
        var inputName = operationInput.attr('name').replace('[operation]', '[sort_order]');
        row.append('<input type="hidden" name="' + inputName + '" value="' + index + '">');
      }
    }
  });
}